module.exports = __webpack_public_path__ + "img/hr-car-turret-2.d9306cad.png";